import React, { useState } from 'react';
import { Bubble, Table, Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import EditionsTable from './Table';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import Visualis from './Visualis';
import { useIntl } from 'umi';

const EditionsShareCard = (props: any) => {
  const {
    tableData = [],
    unPublishedAppIdList = [],
    segmentOptions,
    tableHeaderOptions,
    cardStatus,
    lineData,
    fixedTableData,
    pageSortAttr,
    onTableSortChage,
    metricSegVal,
    changeSegement,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    retentionMetricSource = 'appannie',
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [metricSegVal, setMetricSegVal] = useState(segmentOptions?.[0]?.value);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_editions_share` })}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-editionsshare-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_editions_share` })}
        disableChartType={['bar', 'pie']}
        activeTab={'line'}
      >
        <div className="retention-segment">
          <Segment
            value={metricSegVal}
            onChange={(value) => {
              changeSegement?.(value);
              // setMetricSegVal(value)
            }}
            options={segmentOptions}
          />
        </div>
        <div className="editionsshare-card-line">
          <Visualis
            lineData={lineData}
            metricSegVal={metricSegVal}
            dateType={dateType}
          />
        </div>
        {/* 表格头部加table-header-normal没有排序样式  table-header是排序样式*/}

        <EditionsTable
          chartSegment={metricSegVal} /**用于表格展示排序 */
          tableData={tableData}
          unPublishedAppIdList={unPublishedAppIdList}
          tableHeaderOptions={tableHeaderOptions}
          fixedTableData={fixedTableData}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
          entityType={entityType}
          gameName={gameName}
          gameCover={gameCover}
          dateType={dateType}
          startDate={startDate}
          endDate={endDate}
          retentionMetricSource={retentionMetricSource}
        />
      </CardSlotV2>
    </div>
  );
};
export default EditionsShareCard;
